export const EMAIL_REGEX = /^\w+@[a-zA-Z_]+?.[a-zA-Z]{2,3}$/;
